import {useParams} from 'react-router-dom'
import React, {  useRef,useEffect, useState, useContext, useReducer, useCallback } from 'react';
import fscpageReducer from "../reducerspwa/fscpageReducer"
import OverviewContainer from '../components/graphs/overviewContainer'
import { StaticRouter } from 'react-router';
const {noop} = StaticRouter
/*we are containerPage. we scall Facbybar pass him filters and the Com witl render as we send props to it */

function SVVisSearchComPage() {
    //we are inet so id is not passed
    console.log('SV*****SVVisSearchComPage')
    //let { id } = useParams();
    //we have no id
    let svparams = { 'id': 4}
    let  filtersInit= {
                
        all: [], // Contains the full data
        //"startDate": "2024-07-22T23:42:55.795+00:00" ,
       // "endDate": "2024-07-22T25:42:55.795+00:00" ,
       startDate : new Date(),
       endDate : new Date(),
       esqueryAdults:"t1",
       esqueryChilds:"m1",
       esqueryInfants:"i0",
       esqueryCabin:"ECONOMY",
       esqueryTripType:"roundtrip",
       
       esqueryText: '',
       esqueryDestText: '',
       dataSourceSV : ['Burns Bay Road', 'Downing Street', 'Wall Street'],
    
      
        key: 'selection',
        "hotelsSelected":{"value": "kenServer", "label": "kenServer"},
        hotels: {
            
            options:[
                { value: 'jen', label: 'jen1Server' },
                { value: 'ken', label: 'ken1Server' },
                { value: 'ben', label: 'ben1Server' }
            ],
            values: { value: 'ken', label: 'ken1Server' }
    },
        HOTEL_DEST: {
            id: "HOTEL_DEST_STATUS", 
            defaultOptions: [], 
            options: [],
            label: "Hptel Location",
            values: [],
            showing: []

        },
        HOTEL_DATE_RANGE: {
           
                startDate: new Date(),
                endDate: new Date(),
           
            key: 'selection'
            
        },
        APP_OPERATIONAL_STATUS:{
            id: "APP_OPERATIONAL_STATUS", 
            defaultOptions: [], 
            options: [],
            label: "Status",
            values: [],
            showing: []
        },
        
        APPLICATION_NAME: {
            id: "APPLICATION_NAME",
            defaultOptions: [],
            options: [],
            label: "Applications",
            values: [],
            showing: []
        }
      
    }

    const [filters, setFilters] = useState(filtersInit)
    const [{loading, error, my_data}, dispatch]= useReducer(fscpageReducer, filtersInit);

/*

    const getDinoCB = useCallback(() => {
        console.log('Step 2 - reactses useCall back fired');
        loadFscpageAction(dispatch);
    }, [dispatch]);
*/

    useEffect(() => {
        console.log('Step 1 - uses effect filter changes render container SVFlySearcComPage');
        console.log(filters)
       
    }, [filters]);

    console.log('SV*****SVVisSearchComPage',svparams)
    
    return (
        <noop>
            
             <OverviewContainer svparams={svparams} ></OverviewContainer>
             
        </noop>
       
        
    );
}
export default SVVisSearchComPage